// Note: Food Runs is only available to foodMover plan users, so no upgrade step needed
export const foodRunsOverviewTour = {
  tourKey: 'food_runs_overview',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: ['foodMover'],
  },
  steps: [
    {
      // Welcome step - centered
      title: 'tours.food-runs-overview.welcome.title',
      content: 'tours.food-runs-overview.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="food-runs-table"]',
      title: 'tours.food-runs-overview.table.title',
      content: 'tours.food-runs-overview.table.content',
      placement: 'top',
    },
  ],
};
